/* dev/assets/js/o-gallery.js */
(function ($) {
    "use strict";
    $(function () {

        if ($('.gallery').length) {
            baguetteBox.run('.gallery', {
                animation: 'fadeIn',
                noScrollbars: false,
                loop: true
            });
        }

    });
})(jQuery);

